
import draggable from "vuedraggable";
import { Vue, Component } from "vue-property-decorator";
import {
  SplitTruckSummaryOrder,
  SplitTruckSummaryTruck
} from "../../models/api/trucks/splitTrucks";
import { formatDate } from "@/utils";
import SplitTruckOrdersTable from "./SplitTruckOrdersTable.vue";
import TruckModule from "@/store/modules/truck";
import { getModule } from "vuex-module-decorators";

const truckModuleState = getModule(TruckModule);

@Component({
  components: {
    draggable,
    SplitTruckOrdersTable
  }
})
export default class SplitTruckTableView extends Vue {
  get originalTruckDeliveryDate() {
    return truckModuleState.splitTruckSummary.existingTruck.deliveryDate;
  }

  set originalTruckDeliveryDate(val) {
    truckModuleState.setSplitTruckSummaryDeliveryDate({ original: true, value: val });
  }

  get originalTruckName() {
    return truckModuleState.splitTruckSummary.existingTruck.truckName;
  }

  set originalTruckName(val) {
    truckModuleState.setSplitTruckSummaryTruckName({ original: true, value: val });
  }

  get originalTruckDriverName() {
    return truckModuleState.splitTruckSummary.existingTruck.driver;
  }

  set originalTruckDriverName(val) {}

  get originalTruckMaxCubes() {
    return truckModuleState.splitTruckSummary.existingTruck.maxCubes;
  }

  set originalTruckMaxCubes(val) {
    truckModuleState.setSplitTruckSummaryMaxCubes({ original: true, value: val });
  }

  get originalTruckOrders(): SplitTruckSummaryOrder[] {
    return truckModuleState.splitTruckSummary.existingTruck.orders;
  }

  set originalTruckOrders(val) {
    truckModuleState.setSplitTruckSummaryOriginalOrders(val);
  }

  get newTruckOrders(): SplitTruckSummaryOrder[] {
    return truckModuleState.splitTruckSummary.newTruck.orders;
  }

  set newTruckOrders(val) {
    truckModuleState.setSplitTruckSummaryNewOrders(val);
  }

  get newTruckDeliveryDate() {
    return truckModuleState.splitTruckSummary.newTruck.deliveryDate;
  }

  get newTruckName() {
    return truckModuleState.splitTruckSummary.newTruck.truckName;
  }

  set newTruckName(val) {
    truckModuleState.setSplitTruckSummaryTruckName({ original: false, value: val });
  }

  get newTruckDriverName() {
    return truckModuleState.splitTruckSummary.newTruck.driver;
  }

  get newTruckMaxCubes() {
    return truckModuleState.splitTruckSummary.newTruck.maxCubes;
  }

  set newTruckMaxCubes(val) {
    truckModuleState.setSplitTruckSummaryMaxCubes({ original: false, value: val });
  }

  getTotalCubesForTruck(truck: SplitTruckSummaryTruck): number {
    return truck.orders.reduce((sum, item) => sum + item.cubes, 0);
  }

  format(date) {
    return formatDate(date);
  }

  get summary() {
    return truckModuleState.splitTruckSummary;
  }

  truckCubesExceedsMax(truck: SplitTruckSummaryTruck): boolean {
    return this.getTotalCubesForTruck(truck) > truck.maxCubes;
  }
}
